import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = { text: String }
  static targets = ["button"]

  connect() {
    // Check if clipboard API is available
    this.supported = !!navigator.clipboard
    if (!this.supported) {
      this.element.style.display = 'none'
    }
  }

  copy(event) {
    event.preventDefault()
    
    if (!this.supported) {
      return
    }

    const text = this.textValue || this.element.dataset.clipboardTextValue
    
    navigator.clipboard.writeText(text).then(() => {
      this.showSuccess()
    }).catch(() => {
      this.showError()
    })
  }

  showSuccess() {
    const originalText = this.element.innerHTML
    this.element.innerHTML = `
      <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
      </svg>
      Copied!
    `
    this.element.classList.add('text-green-600', 'border-green-300')
    
    setTimeout(() => {
      this.element.innerHTML = originalText
      this.element.classList.remove('text-green-600', 'border-green-300')
    }, 2000)
  }

  showError() {
    const originalText = this.element.innerHTML
    this.element.innerHTML = `
      <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path>
      </svg>
      Error
    `
    this.element.classList.add('text-red-600', 'border-red-300')
    
    setTimeout(() => {
      this.element.innerHTML = originalText
      this.element.classList.remove('text-red-600', 'border-red-300')
    }, 2000)
  }
} 